import { Modal } from '@shared/ui/Modal'
import { Button } from '@shared/ui/Button'
import { ENV } from '@shared/config/env'
import type { PaymentProvider } from '@entities/user'
import styles from './GracePeriodModal.module.css'

interface GracePeriodModalProps {
  /** Провайдер подписки — у Tribute текст про баланс карты и попытки продления */
  provider?: PaymentProvider | null
  /** Переход на страницу профиля (к блоку подписки). Закрытие модалки — снаружи. */
  onGoToProfile: () => void
  onClose: () => void
}

/**
 * Попап грейс-периода: подписка скоро закончится.
 * Главная кнопка ведёт на профиль; крестик / клик по overlay — просто закрывают.
 */
export const GracePeriodModal = ({ provider, onGoToProfile, onClose }: GracePeriodModalProps) => {
  const variant = ENV.IS_TG ? 'bottomSheet' : 'center'
  const isTribute = provider === 'tribute'

  return (
    <Modal onClose={onClose} variant={variant} showClose>
      <div className={styles.content}>
        <h3 className={styles.title}>Подписка скоро закончится</h3>
        <p className={styles.text}>
          {isTribute
            ? 'Не удалось списать оплату. Проверьте, пожалуйста, баланс карты — в течение недели мы будем повторять попытки продлить подписку.'
            : 'Срок действия вашей подписки подходит к концу. Продлите её, чтобы не потерять доступ к контенту.'}
        </p>

        <Button onClick={onGoToProfile} block>
          Перейти к подписке
        </Button>
      </div>
    </Modal>
  )
}
